import type { CSSProperties } from "react";
import { Button } from "./ui/button";

export interface LoadingOverlayProps {
  style?: CSSProperties;
  fullScreen?: boolean;
  errorMessage?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export function ErrorOverlay({
  style,
  fullScreen,
  errorMessage,
  buttonText = "Retry",
  onButtonClick,
}: LoadingOverlayProps) {
  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        inset: 0,
        alignContent: "center",
        textAlign: "center",

        background: "rgba(0, 0, 0, 0.5)",
        color: "white",

        transitionProperty: "opacity, contentVisibility, pointer-events",
        transitionDuration: "300ms",
        transitionTimingFunction: "linear",
        transitionBehavior: "allow-discrete",

        opacity: errorMessage ? 1 : 0,
        contentVisibility: errorMessage ? "visible" : "hidden",
        pointerEvents: errorMessage ? "all" : "none",

        display: "grid",
        gap: "1em",

        ...style,
      }}
    >
      {errorMessage && <div>Error: {errorMessage}</div>}
      {onButtonClick && (
        <Button onClick={onButtonClick}>{buttonText}</ Button>
      )}
    </div>
  );
}
